import { crabDevice } from '@hfzq/crab-utils';
import { useXfnGoback } from './use-xfn-goback';

/**
 * iOS设备webview隐藏之后元素概率性的会出现边框问题
 * 可通过重绘整个页面解决
 */
export const useForceRepaint = () => {
  if (!crabDevice.isIOS) {
    return;
  }
  const forceRepaint = () => {
    const { body } = document;
    const displayStyle = body.style.display;
    body.style.display = 'none';
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const _ = body.offsetHeight;
    body.style.display = displayStyle;
  };
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useXfnGoback(forceRepaint);
};
